import React from "react";
import { FormattedMessage } from "react-intl";

import Tutorial from "../../../../Tutorial";
import { IProps } from "./interfaces";
import messages from "./messages";
import FormattedHtmlMessage from "../../../../../../common/helpers/FormattedHtmlMessage";

const RhythmTutorial = ({ close, title }: IProps) => (
    <Tutorial close={close} title={title}>
        {[
            {
                title: <FormattedMessage {...messages.title1} />,
                content: <FormattedHtmlMessage {...messages.description1} />,
            },
            {
                title: <FormattedMessage {...messages.title3} />,
                content: <FormattedHtmlMessage {...messages.description3} />,
            },
            {
                title: <FormattedMessage {...messages.title4} />,
                content: <FormattedHtmlMessage {...messages.description4} />,
            },
        ]}
    </Tutorial>
);

export default RhythmTutorial;
